export enum QueriesTypeEnum {
  ALL = 'all',
  WITH_RESULTS = 'withResults',
  WITHOUT_RESULTS = 'withoutResults'
}
